import { Tag } from '../../Context/dist/effect-Context.esm.js';

/**
 * @since 2.0.0
 */

/**
 * The `TestConfig` service provides access to default configuration settings
 * used by tests, including the number of times to repeat tests to ensure
 * they are stable, the number of times to retry flaky tests, the sufficient
 * number of samples to check from a random variable, and the maximum number of
 * shrinkings to minimize large failures.
 *
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 */
const TestConfig = /*#__PURE__*/Tag( /*#__PURE__*/Symbol.for("effect/TestConfig"));

/**
 * @since 2.0.0
 */
const make = params => params;

export { TestConfig, make };
